/* eslint-disable no-nested-ternary */
import React, { Fragment, useRef } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3Text from '@Uilib/h3Text';
import { Popover, Spin, Table } from 'antd';
import Helpers from '@Apis/helpers';
import './style.scss';

/**
 *
 */
function MetricInvExpirySplit({
  data, loading, tenantIds, MONEY, user,
}) {
  const getExpiryGrouping = (expiryGroups) => {
    const expired = {
      stock_value: 0,
      item_count: 0,
      batch_count: 0,
      category_grouping: [],
    };
    const nearExpiry = {
      stock_value: 0,
      item_count: 0,
      batch_count: 0,
      category_grouping: [],
    };
    const goodStock = {
      stock_value: 0,
      item_count: 0,
      batch_count: 0,
      category_grouping: [],
    };
    const totalStock = {
      stock_value: 0,
      item_count: 0,
      batch_count: 0,
      category_grouping: [],
    };
    for (let i = 0; i < expiryGroups?.length; i++) {
      if (expiryGroups[i]?.expiry_group === 'Expired') {
        expired.stock_value += expiryGroups[i]?.stock_value;
        expired.item_count += expiryGroups[i]?.item_count;
        expired.batch_count += expiryGroups[i]?.batch_count;
        expired.category_grouping = expiryGroups[i]?.expiry_product_cat_grouping?.map((item) => ({ id: item?.product_category || 'Other', value: item?.stock_value, label: item?.product_category || 'Other' }));
        totalStock.stock_value += expiryGroups[i]?.stock_value > 1 ? Math.log(expiryGroups[i]?.stock_value) : 0.1;
        totalStock.item_count += expiryGroups[i]?.item_count;
        totalStock.batch_count += expiryGroups[i]?.batch_count;
      }
      if (expiryGroups[i]?.expiry_group === '0%-25% Expiry') {
        nearExpiry.stock_value += expiryGroups[i]?.stock_value;
        nearExpiry.item_count += expiryGroups[i]?.item_count;
        nearExpiry.batch_count += expiryGroups[i]?.batch_count;
        nearExpiry.category_grouping = expiryGroups[i]?.expiry_product_cat_grouping?.map((item) => ({ id: item?.product_category || 'Other', value: item?.stock_value, label: item?.product_category || 'Other' }));
        totalStock.stock_value += expiryGroups[i]?.stock_value > 1 ? Math.log(expiryGroups[i]?.stock_value) : 0.1;
        totalStock.item_count += expiryGroups[i]?.item_count;
        totalStock.batch_count += expiryGroups[i]?.batch_count;
      }
      if (['25%-50% Expiry', '50%-75% Expiry', '75%-100% Expiry'].includes(expiryGroups[i]?.expiry_group)) {
        goodStock.stock_value += expiryGroups[i]?.stock_value;
        goodStock.item_count += expiryGroups[i]?.item_count;
        goodStock.batch_count += expiryGroups[i]?.batch_count;
        if (goodStock?.category_grouping?.length === 0) {
          goodStock.category_grouping = expiryGroups[i]?.expiry_product_cat_grouping?.map((item) => ({ id: item?.product_category || 'Other', value: item?.stock_value, label: item?.product_category || 'Other' }));
        } else {
          expiryGroups[i]?.expiry_product_cat_grouping?.map((item) => {
            const category = item?.product_category || 'Other';
            if (!goodStock.category_grouping.find((ctg) => ctg?.label === category)) {
              goodStock.category_grouping.push({ id: category, value: item?.stock_value, label: category });
            } else {
              goodStock.category_grouping.find((ctg) => ctg?.label === category).value += item?.stock_value;
            }
          });
        }
      }
    }
    totalStock.stock_value += goodStock?.stock_value > 1 ? Math.log(goodStock?.stock_value) : 0.1;
    totalStock.item_count += goodStock?.item_count;
    totalStock.batch_count += goodStock?.batch_count;
    return {
      expired,
      nearExpiry,
      goodStock,
      totalStock,
    };
  };

  const appendCommonQueryParamsInURL = ({ url, callback }) => {
    let updatedURL = `${url}&department_id=${Helpers.getDepartmentId(user)}&quantity_class=POSITIVE_QUANTITY_BATCHES`;

    if (callback) {
      updatedURL = callback(updatedURL);
    }
    return updatedURL;
  }

  const columns = [
    {
      title: '',
      render: (text, record) => (
        <div style={{ marginBottom: '10px' }}>
          <H3Text text={record?.tenant_name} className="" />
          <H3Text text={MONEY(record?.stock_value)} className="" />
          <H3Text text={`${record?.batch_count} batches / ${record?.item_count} SKU`} className="" />
          <div className="metric-inv__expiry_split__bar" style={{ height: '8px' }}>
            <Popover title={(
              <div className="metric-inv__expiry_split__bar-info">
                <H3Text text={MONEY(getExpiryGrouping(record?.expiry_grouping)?.expired?.stock_value)} className="metric-inv__expiry_split__bar-info-value" />
                <H3Text text={`${getExpiryGrouping(record?.expiry_grouping)?.expired?.batch_count} Batches of ${getExpiryGrouping(record?.expiry_grouping)?.expired?.item_count} Products`} className="metric-inv__expiry_split__bar-info-count" />
                <div className="flex-display">
                  <H3Text text="Expired" className="metric-inv__expiry_split__bar-info-text" />
                  <div style={{
                    marginLeft: 'auto', textDecoration: 'underline', color: '#2d7cf7', fontSize: '11px',
                  }}
                  >
                    <Link to={appendCommonQueryParamsInURL({ url: `/inventory/manage?tab=/product-batches&page=1&limit=10&tenant=${record?.tenant_id}&sortOrder=ASC&expiry_status=Expired&isRejectedBatch=false`, callback: Helpers.appendSystemDefaultFilterIdInURL })} target="_blank">view</Link>
                  </div>
                </div>

              </div>
            )}
            >
              <div className="metric-inv__expiry_split__bar-expired" style={{ width: `${((((getExpiryGrouping(record?.expiry_grouping)?.expired?.stock_value > 1 ? Math.log(getExpiryGrouping(record?.expiry_grouping)?.expired?.stock_value) : 0.1) / (getExpiryGrouping(record?.expiry_grouping)?.totalStock?.stock_value)) || 0) * 100)}%`, backgroundColor: data?.currentColor }} />
            </Popover>
            <Popover title={(
              <div className="metric-inv__expiry_split__bar-info">
                <H3Text text={MONEY(getExpiryGrouping(record?.expiry_grouping)?.nearExpiry?.stock_value)} className="metric-inv__expiry_split__bar-info-value" />
                <H3Text text={`${getExpiryGrouping(record?.expiry_grouping)?.nearExpiry?.batch_count} Batches of ${getExpiryGrouping(record?.expiry_grouping)?.nearExpiry?.item_count} Products`} className="metric-inv__expiry_split__bar-info-count" />
                <div className="flex-display">
                  <H3Text text="Near Expiry (<25% Life)" className="metric-inv__expiry_split__bar-info-text" />
                  <div style={{
                    marginLeft: 'auto', textDecoration: 'underline', color: '#2d7cf7', fontSize: '11px',
                  }}
                  >
                    <Link to={appendCommonQueryParamsInURL({url: `/inventory/manage?tab=/product-batches&page=1&limit=10&tenant=${record?.tenant_id}&sortOrder=ASC&expiry_status=Near%20Expiry&isRejectedBatch=false`, callback: Helpers.appendSystemDefaultFilterIdInURL })} target="_blank">view</Link>
                  </div>
                </div>
              </div>
            )}
            >
              <div className="metric-inv__expiry_split__bar-near-expiry" style={{ width: `${((((getExpiryGrouping(record?.expiry_grouping)?.nearExpiry?.stock_value > 1 ? Math.log(getExpiryGrouping(record?.expiry_grouping)?.nearExpiry?.stock_value) : 0.1) / (getExpiryGrouping(record?.expiry_grouping)?.totalStock?.stock_value)) || 0) * 100)}%`, backgroundColor: data?.overdueColor }} />
            </Popover>
            <Popover title={(
              <div className="metric-inv__expiry_split__bar-info">
                <H3Text text={MONEY(getExpiryGrouping(record?.expiry_grouping)?.goodStock?.stock_value)} className="metric-inv__expiry_split__bar-info-value" />
                <H3Text text={`${getExpiryGrouping(record?.expiry_grouping)?.goodStock?.batch_count} Batches of ${getExpiryGrouping(record?.expiry_grouping)?.goodStock?.item_count} Products`} className="metric-inv__expiry_split__bar-info-count" />
                <div className="flex-display">
                  <H3Text text="Healthy (>25% Life)" className="metric-inv__expiry_split__bar-info-text" />
                  <div style={{
                    marginLeft: 'auto', textDecoration: 'underline', color: '#2d7cf7', fontSize: '11px',
                  }}
                  >
                    <Link to={appendCommonQueryParamsInURL({url: `/inventory/manage?tab=/product-batches&page=1&limit=10&tenant=${record?.tenant_id}&sortOrder=ASC&expiry_status=Good%20Stock&isRejectedBatch=false`, callback: Helpers.appendSystemDefaultFilterIdInURL })} target="_blank">view</Link>
                  </div>
                </div>
              </div>
            )}
            >
              <div className="metric-inv__expiry_split__bar-good-stock" style={{ width: `${((((getExpiryGrouping(record?.expiry_grouping)?.goodStock?.stock_value > 1 ? Math.log(getExpiryGrouping(record?.expiry_grouping)?.goodStock?.stock_value) : 0.1) / (getExpiryGrouping(record?.expiry_grouping)?.totalStock?.stock_value)) || 0) * 100)}%`, backgroundColor: data?.overdueColor }} />
            </Popover>
          </div>
        </div>
      ),
      responsive: ['xs'],
    },
    {
      title: 'Location',
      render: (text, record) => <H3Text text={record?.tenant_name?.trim()?.length > 10 ? `${record?.tenant_name.trim()?.substring(0, 10)}..` : record?.tenant_name} className="" />,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'Stock Value',
      render: (text, record) => <H3Text text={MONEY(record?.stock_value)} className="" />,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'Products',
      render: (text, record) => <H3Text text={`${record?.batch_count} batches / ${record?.item_count} SKU`} className="" />,
      responsive: ['sm', 'md', 'lg', 'xxl'],
    },
    {
      title: 'Validity',
      width: '100px',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (text, record) => (
        <div className="metric-inv__expiry_split__bar" style={{ height: '8px' }}>
          <Popover title={(
            <div className="metric-inv__expiry_split__bar-info">
              <H3Text text={MONEY(getExpiryGrouping(record?.expiry_grouping)?.expired?.stock_value)} className="metric-inv__expiry_split__bar-info-value" />
              <H3Text text={`${getExpiryGrouping(record?.expiry_grouping)?.expired?.batch_count} Batches of ${getExpiryGrouping(record?.expiry_grouping)?.expired?.item_count} Products`} className="metric-inv__expiry_split__bar-info-count" />
              <div className="flex-display">
                <H3Text text="Expired" className="metric-inv__expiry_split__bar-info-text" />
                <div style={{
                  marginLeft: 'auto', textDecoration: 'underline', color: '#2d7cf7', fontSize: '11px',
                }}
                >
                  <Link to={appendCommonQueryParamsInURL({url: `/inventory/manage?tab=/product-batches&page=1&limit=10&tenant=${record?.tenant_id}&sortOrder=ASC&expiry_status=Expired&isRejectedBatch=false`, callback: Helpers.appendSystemDefaultFilterIdInURL })} target="_blank">view</Link>
                </div>
              </div>

            </div>
          )}
          >
            <div className="metric-inv__expiry_split__bar-expired" style={{ width: `${((((getExpiryGrouping(record?.expiry_grouping)?.expired?.stock_value > 1 ? Math.log(getExpiryGrouping(record?.expiry_grouping)?.expired?.stock_value) : 0.1) / (getExpiryGrouping(record?.expiry_grouping)?.totalStock?.stock_value)) || 0) * 100)}%`, backgroundColor: data?.currentColor }} />
          </Popover>
          <Popover title={(
            <div className="metric-inv__expiry_split__bar-info">
              <H3Text text={MONEY(getExpiryGrouping(record?.expiry_grouping)?.nearExpiry?.stock_value)} className="metric-inv__expiry_split__bar-info-value" />
              <H3Text text={`${getExpiryGrouping(record?.expiry_grouping)?.nearExpiry?.batch_count} Batches of ${getExpiryGrouping(record?.expiry_grouping)?.nearExpiry?.item_count} Products`} className="metric-inv__expiry_split__bar-info-count" />
              <div className="flex-display">
                <H3Text text="Near Expiry (<25% Life)" className="metric-inv__expiry_split__bar-info-text" />
                <div style={{
                  marginLeft: 'auto', textDecoration: 'underline', color: '#2d7cf7', fontSize: '11px',
                }}
                >
                  <Link to={appendCommonQueryParamsInURL({url: `/inventory/manage?tab=/product-batches&page=1&limit=10&tenant=${record?.tenant_id}&sortOrder=ASC&expiry_status=Near%20Expiry&isRejectedBatch=false`, callback: Helpers.appendSystemDefaultFilterIdInURL})} target="_blank">view</Link>
                </div>
              </div>
            </div>
          )}
          >
            <div className="metric-inv__expiry_split__bar-near-expiry" style={{ width: `${((((getExpiryGrouping(record?.expiry_grouping)?.nearExpiry?.stock_value > 1 ? Math.log(getExpiryGrouping(record?.expiry_grouping)?.nearExpiry?.stock_value) : 0.1) / (getExpiryGrouping(record?.expiry_grouping)?.totalStock?.stock_value)) || 0) * 100)}%`, backgroundColor: data?.overdueColor }} />
          </Popover>
          <Popover title={(
            <div className="metric-inv__expiry_split__bar-info">
              <H3Text text={MONEY(getExpiryGrouping(record?.expiry_grouping)?.goodStock?.stock_value)} className="metric-inv__expiry_split__bar-info-value" />
              <H3Text text={`${getExpiryGrouping(record?.expiry_grouping)?.goodStock?.batch_count} Batches of ${getExpiryGrouping(record?.expiry_grouping)?.goodStock?.item_count} Products`} className="metric-inv__expiry_split__bar-info-count" />
              <div className="flex-display">
                <H3Text text="Healthy (>25% Life)" className="metric-inv__expiry_split__bar-info-text" />
                <div style={{
                  marginLeft: 'auto', textDecoration: 'underline', color: '#2d7cf7', fontSize: '11px',
                }}
                >
                  <Link to={appendCommonQueryParamsInURL({url: `/inventory/manage?tab=/product-batches&page=1&limit=10&tenant=${record?.tenant_id}&sortOrder=ASC&expiry_status=Good%20Stock&isRejectedBatch=false`, callback: Helpers.appendSystemDefaultFilterIdInURL})} target="_blank">view</Link>
                </div>
              </div>
            </div>
          )}
          >
            <div className="metric-inv__expiry_split__bar-good-stock" style={{ width: `${((((getExpiryGrouping(record?.expiry_grouping)?.goodStock?.stock_value > 1 ? Math.log(getExpiryGrouping(record?.expiry_grouping)?.goodStock?.stock_value) : 0.1) / (getExpiryGrouping(record?.expiry_grouping)?.totalStock?.stock_value)) || 0) * 100)}%`, backgroundColor: data?.overdueColor }} />
          </Popover>
        </div>
      ),
    },
  ];

  const getTenantExpiryGrouping = (tenantGrouping, tenantExpiryGrouping) => {
    const tenants = {};
    for (let i = 0; i < tenantGrouping?.length; i++) {
      tenants[tenantGrouping[i]?.tenant_id] = tenantGrouping[i];
    }
    for (let i = 0; i < tenantExpiryGrouping?.length; i++) {
      tenants[tenantExpiryGrouping[i]?.tenant_id] = {
        ...tenants[tenantExpiryGrouping[i]?.tenant_id],
        expiry_grouping: tenantExpiryGrouping[i]?.expiry_grouping,
      };
    }
    const tenantsData = Object.values(tenants);
    return tenantsData.sort((a, b) => {
      const x = a.stock_value; const y = b.stock_value;
      return ((x > y) ? -1 : ((x < y) ? 1 : 0));
    });
  };

  const acceptedOverallExpiryGroups = data?.accepted_stock?.[0]?.expiry_grouping;
  return (
    <Fragment>
      <div className="metric-inv__expiry_split__wrapper">
        {loading && (
          <div className="widget-loader">
            <Spin />
          </div>
        )}
        <div className="metric-inv__expiry_split">
          <H3Text text="Stock Value" className="metric-inv__expiry_split__title" />
          <div className="metric-inv__expiry_split__details">
            <H3Text text={MONEY(data?.accepted_stock?.[0]?.stock_value || '0')} className="metric-inv__expiry_split__value" />
            <div className="metric-inv__expiry_split__count">
              <H3Text text={`${data?.accepted_stock?.[0]?.batch_count} Batches of`} />
              <H3Text text={`${data?.accepted_stock?.[0]?.item_count} Products In Stock`} />
            </div>
          </div>
          <div className="metric-inv__expiry_split__bar" style={{ marginTop: '20px', marginBottom: '10px', height: '10px' }}>
            <Popover title={(
              <div className="metric-inv__expiry_split__bar-info">
                <H3Text text={MONEY(getExpiryGrouping(acceptedOverallExpiryGroups)?.expired?.stock_value)} className="metric-inv__expiry_split__bar-info-value" />
                <H3Text text={`${getExpiryGrouping(acceptedOverallExpiryGroups)?.expired?.batch_count} Batches of ${getExpiryGrouping(acceptedOverallExpiryGroups)?.expired?.item_count} Products`} className="metric-inv__expiry_split__bar-info-count" />
                <div style={{ display: 'flex' }}>
                  <H3Text text="Expired" className="metric-inv__expiry_split__bar-info-text" />
                  <div style={{
                    marginLeft: 'auto', textDecoration: 'underline', color: '#2d7cf7', fontSize: '11px',
                  }}
                  >
                    <Link to={Helpers.appendSystemDefaultFilterIdInURL(`/inventory/manage?tab=/product-batches&page=1&limit=10&tenant=${tenantIds}&sortOrder=ASC&expiry_status=Expired&isRejectedBatch=false`)} target="_blank">view</Link>
                  </div>
                </div>

              </div>
            )}
            >
              <div className="metric-inv__expiry_split__bar-expired" style={{ width: `${((((getExpiryGrouping(acceptedOverallExpiryGroups)?.expired?.stock_value > 1 ? Math.log(getExpiryGrouping(acceptedOverallExpiryGroups)?.expired?.stock_value) : Math.log(2)) / (getExpiryGrouping(acceptedOverallExpiryGroups)?.totalStock?.stock_value)) || 0) * 100)}%`, backgroundColor: data?.currentColor }} />
            </Popover>
            <Popover title={(
              <div className="metric-inv__expiry_split__bar-info">
                <H3Text text={MONEY(getExpiryGrouping(acceptedOverallExpiryGroups)?.nearExpiry?.stock_value)} className="metric-inv__expiry_split__bar-info-value" />
                <H3Text text={`${getExpiryGrouping(acceptedOverallExpiryGroups)?.nearExpiry?.batch_count} Batches of ${getExpiryGrouping(acceptedOverallExpiryGroups)?.nearExpiry?.item_count} Products`} className="metric-inv__expiry_split__bar-info-count" />
                <div style={{ display: 'flex' }}>
                  <H3Text text="Near Expiry (<25% Life)" className="metric-inv__expiry_split__bar-info-text" />
                  <div style={{
                    marginLeft: 'auto', textDecoration: 'underline', color: '#2d7cf7', fontSize: '11px',
                  }}
                  >
                    <Link to={Helpers.appendSystemDefaultFilterIdInURL(`/inventory/manage?tab=/product-batches&page=1&limit=10&tenant=${tenantIds}&sortOrder=ASC&expiry_status=Near%20Expiry&isRejectedBatch=false`)} target="_blank">view</Link>
                  </div>
                </div>
              </div>
            )}
            >
              <div className="metric-inv__expiry_split__bar-near-expiry" style={{ width: `${((((getExpiryGrouping(acceptedOverallExpiryGroups)?.nearExpiry?.stock_value > 1 ? Math.log(getExpiryGrouping(acceptedOverallExpiryGroups)?.nearExpiry?.stock_value) : Math.log(2)) / (getExpiryGrouping(acceptedOverallExpiryGroups)?.totalStock?.stock_value)) || 0) * 100)}%`, backgroundColor: data?.overdueColor }} />
            </Popover>
            <Popover title={(
              <div className="metric-inv__expiry_split__bar-info">
                <H3Text text={MONEY(getExpiryGrouping(acceptedOverallExpiryGroups)?.goodStock?.stock_value)} className="metric-inv__expiry_split__bar-info-value" />
                <H3Text text={`${getExpiryGrouping(acceptedOverallExpiryGroups)?.goodStock?.batch_count} Batches of ${getExpiryGrouping(acceptedOverallExpiryGroups)?.goodStock?.item_count} Products`} className="metric-inv__expiry_split__bar-info-count" />
                <div style={{ display: 'flex' }}>
                  <H3Text text="Healthy (>25% Life)" className="metric-inv__expiry_split__bar-info-text" />
                  <div style={{
                    marginLeft: 'auto', textDecoration: 'underline', color: '#2d7cf7', fontSize: '11px',
                  }}
                  >
                    <Link to={Helpers.appendSystemDefaultFilterIdInURL(`/inventory/manage?tab=/product-batches&page=1&limit=10&tenant=${tenantIds}&sortOrder=ASC&expiry_status=Good%20Stock&isRejectedBatch=false`)} target="_blank">view</Link>
                  </div>
                </div>
              </div>
            )}
            >

              <div className="metric-inv__expiry_split__bar-good-stock" style={{ width: `${((((getExpiryGrouping(acceptedOverallExpiryGroups)?.goodStock?.stock_value > 2 ? Math.log(getExpiryGrouping(acceptedOverallExpiryGroups)?.goodStock?.stock_value) : Math.log(2)) / (getExpiryGrouping(acceptedOverallExpiryGroups)?.totalStock?.stock_value)) || 0) * 100)}%`, backgroundColor: data?.overdueColor }} />
            </Popover>
          </div>
          <div className="metric-inv__expiry_split__table">
            <Table
              showHeader
              size="small"
              scroll="scroll"
              columns={columns}
              dataSource={getTenantExpiryGrouping(data?.accepted_stock?.[0]?.tenant_grouping, data?.accepted_stock?.[0]?.tenant_expiry_grouping) || []}
              pagination={getTenantExpiryGrouping(data?.accepted_stock?.[0]?.tenant_grouping, data?.accepted_stock?.[0]?.tenant_expiry_grouping)?.length > 2 ? {
                pageSize: 2,
              } : false}
            />
          </div>

        </div>
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
});

const mapDispatchToProps = (dispatch) => ({
});

MetricInvExpirySplit.propTypes = {
  user: PropTypes.any,
  data: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MetricInvExpirySplit));
